/**
 * 외부 메일 주소를 «가르고 보는» 두 함수.
 *
 * 보내기 화면(`MinutesSendPanel`)과 외부인 칸(`MinutesExternalRecipients`)이 둘 다 쓴다.
 * 한쪽에 두고 다른 쪽이 가져가면 **서로를 import 하는 고리**가 되므로 따로 뒀다.
 *
 * ⛔ 허용 도메인 검사가 «없다» — 「외부 주소 아무나」가 사용자 결정이다. 여기서 보는 것은
 *   **모양뿐**이고, 그것도 서버 400 을 화면에서 미리 보여 주려는 것이다.
 */

/** 쉼표·세미콜론·줄바꿈으로 갈라 적은 주소를 낱개로. */
export function splitAddresses(raw: string): string[] {
  return raw.split(/[,;\n]/).map((s) => s.trim()).filter((s) => s !== '');
}

/**
 * 메일 주소 «모양»인가.
 *
 * ⚠ 이것으로 「진짜 주소인가」를 판정하지 않는다 — 그것은 보내 봐야 안다(그리고 반송은 이력이
 *   아니라 보낸메일함이 말한다). 여기서 걸러 내는 것은 `홍길동` 처럼 **주소가 아닌 글자**다.
 */
export function looksLikeAddress(v: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}
